"use client";

import { motion, useInView } from "framer-motion";
import { useState, useEffect, useRef } from "react";
import Image from "next/image";

const rooms = [
  { id: 1, name: "Rooms", image: "/images/ourroom/our_room_1.webp" },
  { id: 2, name: "Rooms", image: "/images/ourroom/our_room_2.webp" },
  { id: 3, name: "Rooms", image: "/images/ourroom/our_room_3.webp" },
  { id: 4, name: "Rooms", image: "/images/ourroom/our_room_4.webp" },
];

const RoomsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);

  const textRef = useRef(null);
  const galleryRef = useRef(null);

  const isTextInView = useInView(textRef, { once: true });
  const isGalleryInView = useInView(galleryRef, { once: true });

  useEffect(() => {
    const handleResize = () => {
      const count = window.innerWidth < 640 ? 1 : 3;
      setVisibleCount(count);
      setCurrentIndex((prev) => Math.min(prev, rooms.length - count));
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev >= rooms.length - visibleCount ? 0 : prev + 1));
    }, 3000);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearInterval(interval);
    };
  }, [visibleCount]);

  return (
    <section className='py-12 px-4 sm:px-4 lg:px-[130px]'>
      <div className='container mx-auto'>
        <motion.div ref={textRef} initial={{ opacity: 0, y: 100 }} animate={isTextInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8, ease: "easeOut" }} className='mb-8'>
          <h2 className='text-2xl sm:text-3xl font-bold text-teal-500 mb-4'>Our Rooms</h2>
          <p className='text-gray-600 lg:w-[752px]'>Designed for comfort and care, our facility features clean, well-equipped treatment rooms to ensure a safe and welcoming environment for every patient.</p>
        </motion.div>

        <motion.div ref={galleryRef} initial={{ opacity: 0, y: 100 }} animate={isGalleryInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }} className='overflow-hidden'>
          <div className='flex transition-transform duration-500 ease-in-out' style={{ transform: `translateX(-${(100 / visibleCount) * currentIndex}%)` }}>
            {rooms.map((room) => (
              <div key={room.id} className='flex-shrink-0 w-full sm:w-1/3 px-0 lg:px-2' style={{ flex: `0 0 ${100 / visibleCount}%` }}>
                <div className='overflow-hidden rounded-lg shadow-md'>
                  <div className='relative h-64'>
                    <Image src={room.image} alt={room.name} fill className='object-cover' />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <div className='flex justify-center mt-6'>
          {Array.from({
            length: Math.max(1, rooms.length - visibleCount + 1),
          }).map((_, index) => (
            <button key={index} className={`h-2 w-2 rounded-full mx-1 ${currentIndex === index ? "bg-teal-500" : "bg-gray-300"}`} onClick={() => setCurrentIndex(index)} aria-label={`Go to slide ${index + 1}`} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RoomsSection;
